namespace Matrix.Data {
    export interface DataReportViewerModel {
        ReportKey?: string;
        Description?: string;
        Title?: string;
        Parameters?: Serenity.PropertyItem[];
        Columns?: DataReportColumnItem[];
        FrozenColumns?: number;
        ExpandAllGroups?: number;
        QueryType?: DataQueryType;
    }
}
